import { render, staticRenderFns } from "./ManufacturerControl.vue?vue&type=template&id=619ba2a9&scoped=true"
import script from "./ManufacturerControl.vue?vue&type=script&lang=js"
export * from "./ManufacturerControl.vue?vue&type=script&lang=js"
import style0 from "./ManufacturerControl.vue?vue&type=style&index=0&id=619ba2a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619ba2a9",
  null
  
)

export default component.exports